export enum TypeDoc {
  CUSTOMER = 'CUSTOMER',
  QUALITY = 'QUALITY'
}